export default __webpack_public_path__ + "static/media/06.46ad1625.png";